import { useGroupProvider } from "@/context/group-provider";
import RegisterDisclaimer from "./register-disclaimer";
import Register from "./register";
import { RegisterViewState } from "./register-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ScreenRouteNames from "@/constants/screen-route-names";

const RegisterContainer = () => {
  const { groupData } = useGroupProvider();
  const navigate = useNavigate();

  const registrationDisclaimer = groupData?.registrationDisclaimer;
  const hasRegistrationDisclaimer =
    Boolean(registrationDisclaimer) && registrationDisclaimer.trim().length > 0;

  const [viewState, setViewState] = useState<RegisterViewState>(
    hasRegistrationDisclaimer
      ? RegisterViewState.REGISTER_DISCLAIMER
      : RegisterViewState.REGISTER,
  );

  // If groupData loads after first render, ensure we still show disclaimer.
  const [didResolveInitialView, setDidResolveInitialView] = useState(() =>
    Boolean(groupData),
  );

  useEffect(() => {
    if (didResolveInitialView) return;
    if (!groupData) return;

    setViewState(
      hasRegistrationDisclaimer
        ? RegisterViewState.REGISTER_DISCLAIMER
        : RegisterViewState.REGISTER,
    );
    setDidResolveInitialView(true);
  }, [didResolveInitialView, groupData, hasRegistrationDisclaimer]);

  const handleAgree = () => setViewState(RegisterViewState.REGISTER);
  const handleBackToDisclaimer = () =>
    hasRegistrationDisclaimer
      ? setViewState(RegisterViewState.REGISTER_DISCLAIMER)
      : navigate(`/${ScreenRouteNames.LOGIN.path}`, { replace: true });
  const handleBackToLogin = () => {
    navigate(`/${ScreenRouteNames.LOGIN.path}`, { replace: true });
  };

  return viewState === RegisterViewState.REGISTER_DISCLAIMER ? (
    <RegisterDisclaimer
      disclaimerText={registrationDisclaimer ?? ""}
      onAgree={handleAgree}
      onBackToLogin={handleBackToLogin}
    />
  ) : (
    <Register onBackToDisclaimer={handleBackToDisclaimer} />
  );
};

export default RegisterContainer;
